import {CmnComp} from "../../common/CmnComp"
import {ProductCarousel} from "../../carousal/ProductCarousel"
import section02Styles from "./section02.module.css"
import section03Styles from '../section03/section03.module.css'

const data = {
	title: "",
	header: "What is Bazi",
	description: "",
	button: "",
}

const products = [
	{
		title: "",
		description:
			"Bazi, also known as the Four Pillars of Destiny (八字命理), is an ancient Chinese metaphysical system rooted in the principles of balance and harmony. It uses your birth date and time to construct a “chart” that reveals the interaction of the Five Elements—Wood, Fire, Earth, Metal, and Water—in your life. ",
		image: "./Images/section_2_1.jpg",
	},
	{
		title: "",
		description:
			"The Bazi chart provides insights into your personality, strengths, challenges, relationships, career prospects, and even health. Bazi is not fortune-telling; instead, it serves as a map of potential influences, helping you make informed decisions and navigate life’s uncertainties.",
		image: "./Images/section_2_2.jpg",
	},
]

export const Section02 = () => {
	return (
		<section
			id="2"
			className={section02Styles.section02}
		>
			<div>
				<div className={section03Styles.section03}>
					<CmnComp props={data} />
				</div>
			</div>
			<ProductCarousel
				products={products}
			/>
		</section>
	)
}
